import { render } from "./NumberTwoIcon.vue?vue&type=template&id=6c12b53e"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/NumberTwoIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c12b53e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c12b53e', __exports__)) {
    api.reload('6c12b53e', __exports__)
  }
  
  module.hot.accept("./NumberTwoIcon.vue?vue&type=template&id=6c12b53e", () => {
    api.rerender('6c12b53e', render)
  })

}


export default __exports__